"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var operators_1 = require("rxjs/operators");
var core_1 = require("@angular/core");
var idm_dynamic_controls_metadata_1 = require("@synisys/idm-dynamic-controls-metadata");
var services_1 = require("../../../services");
var sis_control_with_settings_1 = require("../../sis-control-with-settings");
var sis_decimal_settings_component_1 = require("./sis-decimal-settings.component");
var Subject_1 = require("rxjs/Subject");
var of_1 = require("rxjs/observable/of");
require("./sis-decimal.component.scss");
var SisDecimalComponent = /** @class */ (function (_super) {
    __extends(SisDecimalComponent, _super);
    function SisDecimalComponent(formattingService) {
        var _this = _super.call(this) || this;
        _this.formattingService = formattingService;
        _this.isReadonly = false;
        _this.toFormat = true;
        _this.valueChange = new core_1.EventEmitter();
        _this._min = Number.NEGATIVE_INFINITY;
        _this._max = Number.POSITIVE_INFINITY;
        _this.destroySubject$ = new Subject_1.Subject();
        _this.isReady = false;
        return _this;
    }
    Object.defineProperty(SisDecimalComponent.prototype, "maxLength", {
        get: function () {
            return this._maxLength;
        },
        set: function (val) {
            this._maxLength = val ? (+val > 0 ? val : '15') : '15';
        },
        enumerable: true,
        configurable: true
    });
    SisDecimalComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.formattingService
            .getLocaleInfo()
            .pipe(operators_1.takeUntil(this.destroySubject$))
            .subscribe(function (localeInfo) {
            _this.numberFormat = localeInfo.numberFormat;
            _this.isReady = true;
        }, console.error);
    };
    Object.defineProperty(SisDecimalComponent.prototype, "ready", {
        get: function () {
            return this.isReady;
        },
        enumerable: true,
        configurable: true
    });
    SisDecimalComponent.prototype.ngOnDestroy = function () {
        this.destroySubject$.next();
        this.destroySubject$.complete();
    };
    Object.defineProperty(SisDecimalComponent.prototype, "max", {
        set: function (val) {
            if (val && val !== '') {
                this._max = +val;
            }
            else {
                this._max = Number.POSITIVE_INFINITY;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisDecimalComponent.prototype, "min", {
        set: function (val) {
            if (val && val !== '') {
                this._min = +val;
            }
            else {
                this._min = Number.NEGATIVE_INFINITY;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisDecimalComponent.prototype, "value", {
        get: function () {
            return this._value + this.getFormatSuffix(this._value);
        },
        set: function (value) {
            if (value || value === 0) {
                this._value = value + '';
                this.checkValue(true, this.toFormat);
            }
            else {
                this.valueChange.emit(null);
                this._value = '';
            }
        },
        enumerable: true,
        configurable: true
    });
    SisDecimalComponent.prototype.handleKeyPress = function (evt) {
        if (evt.which < 48 || evt.which > 57) {
            var eventTarget = evt.target;
            var selection = this._value.substring(eventTarget.selectionStart, eventTarget.selectionEnd);
            if (!((evt.which === 45 &&
                eventTarget.selectionStart === 0 &&
                (this._value.indexOf('-') === -1 ||
                    selection.indexOf('-') !== -1)) ||
                (evt.which === 46 &&
                    (this._value.indexOf('.') === -1 ||
                        selection.indexOf('.') !== -1)))) {
                evt.preventDefault();
            }
        }
    };
    SisDecimalComponent.prototype.getIsReadonly = function () {
        return this.isReadonly;
    };
    SisDecimalComponent.prototype.hasFraction = function (value) {
        return value.includes(this.numberFormat.decimalSeparator);
    };
    SisDecimalComponent.prototype.getFraction = function (value) {
        return value.split(this.numberFormat.decimalSeparator).pop();
    };
    SisDecimalComponent.prototype.getFormatSuffix = function (value) {
        if (value !== '') {
            if (!this.hasFraction(value)) {
                return (this.numberFormat.decimalSeparator +
                    '0'.repeat(this.numberFormat.fractionDigits));
            }
            else if (this.getFraction(value).length <
                this.numberFormat.fractionDigits) {
                return '0'.repeat(this.numberFormat.fractionDigits -
                    this.getFraction(value).length);
            }
        }
        return '';
    };
    SisDecimalComponent.prototype.checkValue = function (emit, format) {
        var _this = this;
        if (this._value === '-') {
            return;
        }
        if (this._value === '') {
            this.valueChange.emit(null);
            return;
        }
        this.formattingService
            .parseNumber(this._value)
            .pipe(operators_1.mergeMap(function (number) {
            if (isNaN(number)) {
                return of_1.of(number);
            }
            else {
                var parsedValue_1 = Math.min(Math.max(number, _this._min), _this._max);
                if (format) {
                    return _this.formattingService
                        .formatNumber(parsedValue_1)
                        .pipe(operators_1.map(function (formatted) {
                        _this._value = formatted;
                        return parsedValue_1;
                    }));
                }
                else {
                    return of_1.of(parsedValue_1);
                }
            }
        }), operators_1.takeUntil(this.destroySubject$))
            .subscribe(function (number) {
            if (isNaN(number)) {
                _this.valueChange.emit(null);
                _this._value = '';
                return;
            }
            if (emit) {
                _this.valueChange.emit(number);
            }
        }, console.error);
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], SisDecimalComponent.prototype, "id", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], SisDecimalComponent.prototype, "isReadonly", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], SisDecimalComponent.prototype, "maxLength", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], SisDecimalComponent.prototype, "toFormat", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], SisDecimalComponent.prototype, "valueChange", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], SisDecimalComponent.prototype, "max", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], SisDecimalComponent.prototype, "min", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], SisDecimalComponent.prototype, "value", null);
    SisDecimalComponent = __decorate([
        core_1.Component({
            moduleId: module.id + '',
            selector: 'sis-decimal',
            template: "\n        <ng-container *ngIf=\"ready\">\n            <ng-container *ngIf=\"!getIsReadonly()\">\n                <mat-form-field\n                    class=\"sis-form-field\"\n                    color=\"accent\"\n                    [floatLabel]=\"'never'\"\n                    [hintLabel]=\"_hint | sisTranslateMultilingual | async\"\n                >\n                    <input\n                        class=\"sis-numeric-input\"\n                        matInput\n                        [(ngModel)]=\"_value\"\n                        [id]=\"id\"\n                        [maxlength]=\"maxLength\"\n                        (blur)=\"checkValue(false, toFormat)\"\n                        (keypress)=\"handleKeyPress($event)\"\n                        (keyup)=\"checkValue(true, false)\"\n                    />\n                </mat-form-field>\n            </ng-container>\n            <ng-container *ngIf=\"getIsReadonly()\">\n                <div class=\"sis-numeric-text\" id=\"{{ id }}\" *ngIf=\"value\">\n                    {{ value }}\n                </div>\n                <span id=\"{{ id }}\" *ngIf=\"!value\" class=\"sis-no-data\">\n                    {{ 'de_no_data' | sisTranslate | async }}\n                </span>\n            </ng-container>\n        </ng-container>\n    ",
        }),
        idm_dynamic_controls_metadata_1.ControlMetadata({
            name: 'Decimal',
            settings: {
                main: sis_decimal_settings_component_1.SisDecimalSettingsComponent,
            },
            template: "\n                        <sis-decimal [id]=\"'%{id}'\" [(value)]=\"%{field}\" [isReadonly]=\"%{isReadonly}\" [hint]=\"%{hint}\"\n                        [max]=\"%{max}\" [min]=\"%{min}\"\n                        [maxLength]=\"%{maxLength}\"\n                        [toFormat]=\"%{toFormat}\">\n                        </sis-decimal>\n                   ",
            cellCount: 3,
            isFieldBound: true,
        }),
        __metadata("design:paramtypes", [services_1.FormattingService])
    ], SisDecimalComponent);
    return SisDecimalComponent;
}(sis_control_with_settings_1.SisControlWithSettings));
exports.SisDecimalComponent = SisDecimalComponent;
//# sourceMappingURL=sis-decimal.component.js.map